import createIcon from '../../createIcon';

/**
 * @component @name SwapCalls
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNC41TDE0IDguNUgxN1YxNS41QzE3IDE2LjYgMTYuMSAxNy41IDE1IDE3LjVDMTMuOSAxNy41IDEzIDE2LjYgMTMgMTUuNVY4LjVDMTMgNi4yOSAxMS4yMSA0LjUgOSA0LjVDNi43OSA0LjUgNSA2LjI5IDUgOC41VjE1LjVIMkw2IDE5LjVMMTAgMTUuNUg3VjguNUM3IDcuNCA3LjkgNi41IDkgNi41QzEwLjEgNi41IDExIDcuNCAxMSA4LjVWMTUuNUMxMSAxNy43MSAxMi43OSAxOS41IDE1IDE5LjVDMTcuMjEgMTkuNSAxOSAxNy43MSAxOSAxNS41VjguNUgyMkwxOCA0LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwapCalls = createIcon('SwapCalls', [
  [
    'path',
    {
      d: 'M18 4.5L14 8.5H17V15.5C17 16.6 16.1 17.5 15 17.5C13.9 17.5 13 16.6 13 15.5V8.5C13 6.29 11.21 4.5 9 4.5C6.79 4.5 5 6.29 5 8.5V15.5H2L6 19.5L10 15.5H7V8.5C7 7.4 7.9 6.5 9 6.5C10.1 6.5 11 7.4 11 8.5V15.5C11 17.71 12.79 19.5 15 19.5C17.21 19.5 19 17.71 19 15.5V8.5H22L18 4.5Z',
      key: 'hsxsha',
    },
  ],
]);

export default SwapCalls;
